import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withKeys as _withKeys, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/button-icons/plus-icon-disabled.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2929dea8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "table table-hover",
  "data-test": "gdt-table"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "First Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Last Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-sm-2" }, "Role"),
    /*#__PURE__*/_createElementVNode("th", null, "Solo"),
    /*#__PURE__*/_createElementVNode("th", null, "Viewpoints"),
    /*#__PURE__*/_createElementVNode("th", null, "Develop"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-sm-3" }, "Team Pathways"),
    /*#__PURE__*/_createElementVNode("th", null, "Share?"),
    /*#__PURE__*/_createElementVNode("th", null, "Organisation"),
    /*#__PURE__*/_createElementVNode("th", null, "Subscription"),
    /*#__PURE__*/_createElementVNode("th", null, "Licence")
  ])
], -1))
const _hoisted_3 = { class: "table-body" }
const _hoisted_4 = { style: {"padding-top":"8px"} }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { "data-test": "gdt-first-name" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { "data-test": "gdt-last-name" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "col-sm-2" }
const _hoisted_11 = {
  class: "role-data",
  "data-test": "gdt-role-tags"
}
const _hoisted_12 = { class: "role-tags" }
const _hoisted_13 = {
  key: 0,
  class: "dropdown-menu user-roles text-sm",
  "data-test": "gdt-member-dropdown"
}
const _hoisted_14 = ["onClick", "data-test", "onKeydown"]
const _hoisted_15 = ["alt"]
const _hoisted_16 = {
  class: "text-sm",
  style: {"margin-bottom":"0"}
}
const _hoisted_17 = ["data-test"]
const _hoisted_18 = ["data-test"]
const _hoisted_19 = ["onClick", "data-test"]
const _hoisted_20 = { class: "flex-col" }
const _hoisted_21 = ["href"]
const _hoisted_22 = ["href"]
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "col-sm-2" }
const _hoisted_25 = {
  key: 0,
  "data-test": "gdt-current-develop"
}
const _hoisted_26 = { style: {"text-decoration":"underline"} }
const _hoisted_27 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_28 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_29 = {
  key: 2,
  class: "text-muted",
  style: {"margin-top":"10px"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, null, -1))
const _hoisted_31 = { class: "col-sm-3" }
const _hoisted_32 = {
  key: 0,
  style: {"text-decoration":"underline","margin-bottom":"0"}
}
const _hoisted_33 = {
  key: 0,
  style: {"text-decoration":"underline","margin-bottom":"0"}
}
const _hoisted_34 = {
  key: 0,
  class: "glyphicon glyphicon-ok",
  "data-test": "gdt-share"
}
const _hoisted_35 = ["href"]
const _hoisted_36 = { "data-test": "gdt-member-sub" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-danger" }, "Conflict between ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-danger" }, " and ", -1))
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "----", -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = ["onClick"]

import moment from "dayjs";
import { ref, watchEffect } from "vue";
import TeamMemberPathway from "../../group-member-table/team-member-pathway.vue";
import { LicenceApiModel, TeamCurrentMemberApiModel } from "../../../api-models";
import { GroupUserRoles } from "./group-user-roles.enum";


export default /*#__PURE__*/_defineComponent({
  __name: 'group-details-table',
  props: {
    teamMembers: {},
    teamId: {}
  },
  emits: [
  "open-role-modal",
  "toggle-licence-modal",
  "toggle-assign-licence-modal",
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const expandedMemberRows = ref<string[]>([]);

const roles = Object.keys(GroupUserRoles).filter((r) => {
  return r !== "Member";
});

const toggleExpansion = (member: TeamCurrentMemberApiModel): void => {
  const { id } = member.userDetails;
  if (!expandedMemberRows.value.includes(id)) {
    expandedMemberRows.value.push(id);
  } else {
    expandedMemberRows.value = expandedMemberRows.value.filter((r) => {
      return r !== id;
    });
  }
};

const isExpanded = (member): boolean => {
  return expandedMemberRows.value.includes(member.userDetails.id);
};

const isAdmin = (member: TeamCurrentMemberApiModel): boolean => {
  const admin = member.roles.filter((role) => {
    return role.role === GroupUserRoles.Admin && role.id === member.userDetails.id;
  });
  return admin.length > 0;
};

const isWatcher = (member: TeamCurrentMemberApiModel): boolean => {
  const watcher = member.roles.filter((role) => {
    return role.role === GroupUserRoles.Watcher && role.id === member.userDetails.id;
  });
  return watcher.length > 0;
};

const rolesNotAssignedToMember = (member: TeamCurrentMemberApiModel): string[] => {
  const allPossibleRoles = roles.map((r) => r.toLowerCase());
  const teamRoles = member.roles
    .filter((role) => {
      return role.groupId === props.teamId && role.id === member.userDetails.id;
    })
    .map((role) => role.role);

  return allPossibleRoles.filter((r) => {
    return !teamRoles.includes(r);
  });
};

const hasActiveLicence = (member: TeamCurrentMemberApiModel): boolean => {
  const autoLicenceId = "00000000-0000-0000-0000-000000000000";
  return member.licence.id !== autoLicenceId;
};

const displayDate = (dateString: string): string => {
  return dateString ? moment(dateString).format("DD/MM/YYYY") : "";
};

const openRoleModal = (member: TeamCurrentMemberApiModel, role: string): void => {
  emit("open-role-modal", member, role);
};

const toggleModal = (member: LicenceApiModel): void => {
  emit("toggle-licence-modal", member);
};

const memberHasConflictingSubscriptions = (member: TeamCurrentMemberApiModel): boolean => {
  return member.subscriptions.length > 1;
};

const memberHasNoSubscriptions = (member: TeamCurrentMemberApiModel): boolean =>
  member.subscriptions.length < 1;

const toggleAssignLicenceModal = (member: TeamCurrentMemberApiModel): void => {
  emit("toggle-assign-licence-modal", member);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_data_table = _resolveDirective("data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createElementBlock("table", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tbody", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMembers, (member) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: member.userDetails.id,
            "data-test": "gdt-row"
          }, [
            _createElementVNode("td", _hoisted_4, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn", isExpanded(member) ? 'btn-collapse-sm' : 'btn-expand-sm']),
                "aria-label": "open more details",
                onClick: ($event: any) => (toggleExpansion(member)),
                "data-test": "gdt-expand-button",
                type: "button"
              }, null, 10, _hoisted_5)
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("a", {
                href: `/admin/user/details/${member.userDetails.id}`
              }, _toDisplayString(member.userDetails.firstName), 9, _hoisted_7)
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createElementVNode("a", {
                href: `/admin/user/details/${member.userDetails.id}`
              }, _toDisplayString(member.userDetails.lastName), 9, _hoisted_9)
            ]),
            _createElementVNode("td", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn btn-default btn-sm", [isAdmin(member) && isWatcher(member) ? '' : 'dropdown-toggle']]),
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false",
                    "data-test": "gdt-member-tag",
                    type: "button"
                  }, " Member ", 2),
                  (rolesNotAssignedToMember(member).length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rolesNotAssignedToMember(member), (role) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: `${member.userDetails.lastName}(${role})`,
                            onClick: ($event: any) => (openRoleModal(member, role)),
                            class: "list-items",
                            "data-test": `gdt-add-${role.toLowerCase()}`,
                            onKeydown: _withKeys(($event: any) => (openRoleModal(member, role)), ["enter"])
                          }, [
                            _createElementVNode("span", null, [
                              _createElementVNode("img", {
                                src: _imports_0,
                                alt: `add ${role.toLowerCase()}`
                              }, null, 8, _hoisted_15)
                            ]),
                            _createElementVNode("p", _hoisted_16, _toDisplayString(role === "admin" ? "team lead" : role), 1)
                          ], 40, _hoisted_14))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.roles, (role) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `${member.userDetails.id} (${role})`,
                    class: "role-tags"
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary btn-sm dropdown-toggle",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false",
                      "data-test": `gdt-${role.role}-tag`
                    }, _toDisplayString(role.role === "admin" ? "Team Lead" : "Watcher"), 9, _hoisted_17),
                    _createElementVNode("ul", {
                      class: "dropdown-menu user-roles text-sm",
                      "data-test": `gdt-${role.role}-dropdown`
                    }, [
                      _createElementVNode("li", {
                        onClick: ($event: any) => (openRoleModal(member, role.role)),
                        "data-test": `gdt-remove-${role.role}`
                      }, " Remove role ", 8, _hoisted_19)
                    ], 8, _hoisted_18)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("td", _hoisted_20, [
              (member.solo.activeReport.linkText !== 'no solo')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: member.solo.activeReport.linkUrl,
                    style: {"font-weight":"bold"},
                    "data-test": "gdt-current-solo"
                  }, _toDisplayString(member.solo.activeReport.linkText), 9, _hoisted_21))
                : _createCommentVNode("", true),
              (member.solo.otherReports.length > 0 && isExpanded(member))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(member.solo.otherReports, (report) => {
                    return (_openBlock(), _createElementBlock("a", {
                      href: report.linkUrl,
                      key: report.linkText,
                      "data-test": "gdt-previous-solo"
                    }, _toDisplayString(report.linkText), 9, _hoisted_22))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              (member.viewpoints.activeReport.linkText !== 'no viewpoints')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: `/viewpoints/view/${member.userDetails.id}`,
                    "data-test": "gdt-viewpoints"
                  }, _toDisplayString(member.viewpoints.activeReport.linkText), 9, _hoisted_23))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_24, [
              (!!member.develop?.currentStrengthProgress)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, _toDisplayString(member.develop.currentStrengthProgress.strengthItemDisplayTitle) + ": ", 1),
                    (!!member.develop.currentStrengthProgress?.lastDayIndex)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, " Completed Day " + _toDisplayString(member.develop.currentStrengthProgress.lastCompletedDayIndex), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_28, "Not started")),
                    (!!member.develop.currentStrengthProgress?.lastReadActionTime)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, " Last activity: " + _toDisplayString(displayDate(member.develop.currentStrengthProgress.lastReadActionTime)), 1))
                      : _createCommentVNode("", true),
                    _hoisted_30
                  ]))
                : _createCommentVNode("", true),
              (member.develop.otherProgress && isExpanded(member))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(member.develop.otherProgress, (progress) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: progress.strengthItemId,
                      "data-test": "gdt-previous-develop"
                    }, [
                      _createTextVNode(_toDisplayString(progress.strengthItemDisplayTitle) + " : Day " + _toDisplayString(progress.lastCompletedDayIndex) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(displayDate(progress.lastReadActionTime)), 1)
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_31, [
              (member.pathways.currentPathwaysInProgress)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (member.pathways.currentPathwaysInProgress.length > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_32, " Current progress: "))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.pathways.currentPathwaysInProgress, (currentPathways, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: currentPathways.cmsStepUid + index,
                        style: {"display":"flex","align-items":"center","margin-bottom":"1rem"},
                        "data-test": "gdt-current-tpathway"
                      }, [
                        (currentPathways.teamId === _ctx.teamId)
                          ? (_openBlock(), _createBlock(TeamMemberPathway, {
                              key: 0,
                              model: currentPathways
                            }, null, 8, ["model"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true),
              (member.pathways.otherProgress && isExpanded(member))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (member.pathways.otherProgress.length > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_33, " Other progress: "))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.pathways.otherProgress, (otherPathways, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: otherPathways.cmsStepUid + index,
                        style: {"display":"flex","align-items":"center","margin-bottom":"1rem"},
                        "data-test": "gdt-previous-tpathway"
                      }, [
                        (otherPathways.teamId === _ctx.teamId)
                          ? (_openBlock(), _createBlock(TeamMemberPathway, {
                              key: 0,
                              model: otherPathways
                            }, null, 8, ["model"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              (member.allowTeamMembersToReadMyReports)
                ? (_openBlock(), _createElementBlock("span", _hoisted_34))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("a", {
                href: `/organisation/details/${member.userDetails.organisation?.id}`,
                "data-test": "gdt-org-name"
              }, _toDisplayString(member.userDetails.organisation?.name), 9, _hoisted_35)
            ]),
            _createElementVNode("td", _hoisted_36, [
              (memberHasConflictingSubscriptions(member))
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode(_component_router_link, {
                      to: `/admin/group/details/${member.subscriptions[0].group.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("'" + _toDisplayString(member.subscriptions[0].group.name) + "'", 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.subscriptions.slice(1), (subscription) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: subscription.group.id
                      }, [
                        _hoisted_39,
                        _createVNode(_component_router_link, {
                          to: `/admin/group/details/${subscription.group.id}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("'" + _toDisplayString(subscription.group.name) + "'", 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
            ]),
            _createElementVNode("td", null, [
              (hasActiveLicence(member))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-default",
                    onClick: ($event: any) => (toggleModal(member.licence)),
                    "data-test": "gdt-delete-licence",
                    type: "button"
                  }, " Delete Licence ", 8, _hoisted_43))
                : (_openBlock(), _createElementBlock("span", _hoisted_44, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (toggleAssignLicenceModal(member)),
                      class: "btn btn-primary",
                      type: "button",
                      "data-test": "gdt-assign-licence"
                    }, " Assign Licence ", 8, _hoisted_45)
                  ]))
            ])
          ]))
        }), 128))
      ])
    ])), [
      [_directive_data_table, {
        paging: false,
        searching: true,
        info: false,
        columnDefs: [{ targets: [-1, -2, -3], orderable: false }],
        order: [[0, 'asc']],
        tempLength: _ctx.teamMembers.length,
      }]
    ])
  ]))
}
}

})